import { Chip } from '@mui/material';
import { ExportJobStatus, EXPORT_JOB_STATUS_LABELS } from '../models/ExportJob';

const statusColor: Record<ExportJobStatus, 'default' | 'warning' | 'success' | 'error'> = {
  [ExportJobStatus.INITIATED]: 'default',
  [ExportJobStatus.CLAIMED]: 'warning',
  [ExportJobStatus.COMPLETED]: 'success',
  [ExportJobStatus.ERRORED]: 'error',
};

interface Props {
  status: ExportJobStatus;
}

const ExportJobStatusChip = ({ status }: Props) => (
  <Chip
    label={EXPORT_JOB_STATUS_LABELS[status] ?? status}
    color={statusColor[status] ?? 'default'}
    size='small'
  />
);

export default ExportJobStatusChip;
